import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "../trpc";
import { getQueryKey } from "@trpc/react-query";
import type { AuthenticationsOutput } from "@zapier/bff";

export function useBulkDeleteAuthentications() {
  const queryClient = useQueryClient();

  const authenticationsKey = getQueryKey(
    trpc.authentication.authentications,
    undefined,
    "any",
  );
  const connectionStatsKey = getQueryKey(
    trpc.authentication.connectionStats,
    undefined,
    "any",
  );

  const mutation = trpc.authentication.bulkDelete.useMutation({
    onMutate: async ({ ids }) => {
      await queryClient.cancelQueries({ queryKey: authenticationsKey });

      const previousData = queryClient.getQueriesData<AuthenticationsOutput>({
        queryKey: authenticationsKey,
      });

      queryClient.setQueriesData(
        {
          queryKey: authenticationsKey,
          type: "active",
        },
        (old: AuthenticationsOutput | undefined) => {
          if (old?.results) {
            const idsSet = new Set(ids);
            return {
              ...old,
              results: old.results.filter((item) => !idsSet.has(item.id)),
            };
          }
          return old;
        },
      );

      return { previousData };
    },
    onError: (_error, _variables, context) => {
      if (context?.previousData) {
        for (const [key, data] of context.previousData) {
          queryClient.setQueryData(key, data);
        }
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: authenticationsKey });
      queryClient.invalidateQueries({ queryKey: connectionStatsKey });
    },
  });

  return {
    bulkDeleteAuthentications: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
}
